import React from 'react'
import { Percent } from '@nominex/nomiswap-sdk'
import { warningSeverity } from 'utils/prices'
import { ONE_BIPS } from 'config/constants'
import { ErrorText } from './styles'

/**
 * Formatted version of price impact text with warning colors
 */
export default function FormattedPriceImpact({ priceImpact }: { priceImpact?: Percent }) {
  return (
    <ErrorText fontSize="14px" color="textPrimary" severity={warningSeverity(priceImpact)}>
      {priceImpact ? (priceImpact.lessThan(ONE_BIPS) ? '<0.01%' : `${priceImpact.toFixed(2)}%`) : '-'}
    </ErrorText>
  )
}
